import { Component, OnInit } from '@angular/core';
import { AuthService } from '../providers/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.css']
})
export class PriceComponent implements OnInit {
  areaData:any = [];
  pricing:any = {};
  priceSearchJson:any = {};
  pricingData:any = { area_id : 0};
  per:any = {"1":"lb", "2":"each", "3":"order"}
  constructor(private auth: AuthService, private route: ActivatedRoute, private router: Router, private spinnerService: Ng4LoadingSpinnerService) {

   }



  ngOnInit() {
    let sid = localStorage.getItem("sid");
    
    this.spinnerService.show();
    if(sid == null){
      this.auth.getarea().then((area) => {
        let response = area.json();
        if(response.replyCode == "error"){
          console.log("error with get area")
        }else{
          this.areaData = response.data;
          this.priceSearchJson = {"area_id": this.areaData[0].id};
          this.pricingData.area_id = this.areaData[0].id;
          this.auth.pricing(this.priceSearchJson).then((user) => {
            let response = user.json();
            this.pricing = user.json().data;
            this.spinnerService.hide();
          })
          .catch((err) =>{
            this.spinnerService.hide();
            this.auth.open(environment.error);
          });
        }
      })
      .catch((err)=>{
        console.log("err hai")
      });
    }else{
      this.auth.getarea().then((area) => {
        let response = area.json();
        if(response.replyCode == "error"){
          console.log("error with get area")
        }else{
          this.areaData = response.data;
          let userData = JSON.parse(localStorage.getItem("currentUser"));
          this.priceSearchJson = {"sid":sid, "area_id":userData.area_id};
          this.pricingData.area_id = userData.area_id;
          this.auth.pricing(this.priceSearchJson).then((user) => {
            let response = user.json();
            this.pricing = user.json().data;
            this.spinnerService.hide();
          })
          .catch((err) =>{
            this.spinnerService.hide();
            this.auth.open(environment.error);
          });
        }
      });
    }
  }

  pricingSubmit(){
    console.log(this.pricingData)
  }

  areaChange(e){
    console.log(this.pricingData);
    let sid = localStorage.getItem("sid");

    this.spinnerService.show();
    if(sid == null){
      this.priceSearchJson = {"area_id": this.pricingData.area_id};
    }else{
      this.priceSearchJson = {"sid":sid,"area_id": this.pricingData.area_id};
    }
    this.auth.pricing(this.priceSearchJson).then((user) => {
      let response = user.json();
      this.pricing = user.json().data;
      this.spinnerService.hide();
    })
    .catch((err) =>{
      this.spinnerService.hide();
      this.auth.open(environment.error);
    });
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/price/price.component.ts